import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=2c2057ff&scoped=true"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=2c2057ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2057ff",
  null
  
)

export default component.exports